import { render, staticRenderFns } from "./SimpleNote.vue?vue&type=template&id=2f3ba8ce"
import script from "./SimpleNote.vue?vue&type=script&lang=js"
export * from "./SimpleNote.vue?vue&type=script&lang=js"
import style0 from "./SimpleNote.vue?vue&type=style&index=0&id=2f3ba8ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports